export default {
  props: {
    height: {type: String, default: '16px'},
    width: {type: String, default: '16px'}
  }
};
